import './App.css';
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import ShopCategory from "./Pages/ShopCategory";
import Product from "./Pages/Product";
import './i18n';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Navbar/>
                <Routes>
                    <Route path="/" element={<ShopCategory category="General"/>}/>
                    <Route path="/AdBlue" element={<ShopCategory category="AdBlue"/>}/>
                    <Route path="/MineralFertilizers" element={<ShopCategory category="MineralFertilizers"/>}/>
                    <Route path="/product" element={<Product/>}>
                        <Route path=':productId' element={<Product/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
            <Footer/>
        </div>
    );
}

export default App;
